exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#modal-lists-customers-edit-customer .modal-dialog{max-width:900px}#modal-lists-customers-edit-customer .modal-content .default-card{width:1px}#modal-lists-customers-edit-customer .modal-content .highlight-green{background-color:green}#modal-lists-customers-edit-customer .modal-content .button-row{margin-top:15px}#modal-lists-customers-edit-customer .modal-content .sources-first-col{width:105px}#modal-lists-customers-edit-customer .modal-content .table{width:100%}", ""]);

// exports
